"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("../api");
const AuthToken_1 = __importDefault(require("./AuthToken"));
const events_1 = require("../events");
const exceptions_1 = require("../api/exceptions");
/**
 * Controllore dell'access token
 *
 * @export
 * @class AuthManager
 */
class AuthManager {
    /**
     * Creates an instance of AuthManager.
     * @memberof AuthManager
     */
    constructor() {
        /**
         * Array di callback chiamate quando l'auth si aggiorna
         *
         * @protected
         * @type {Array<Function>}
         * @memberof AuthManager
         */
        this.updateCallbacks = [];
        /**
         * Callabacks chiamate dopo la vlidazione del token
         *
         * @private
         * @type {*}
         * @memberof AuthManager
         */
        this.verifiedPromise = {
            closures: [],
            resolved: false,
        };
        this.token = new AuthToken_1.default();
        this.status = AuthManager.STATUS_NOT_VERIFIED;
        this.verifyToken().then(() => {
            this.status = AuthManager.STATUS_VERIFIED;
            this.verifiedPromise.closures.map((c) => c());
            this.verifiedPromise.resolved = true;
            this.updateCallbacks.forEach(c => c());
        });
    }
    /**
     * Chiama o setta le funzioni di callback dpo la validazione del token
     *
     * @param {Function} closure
     * @returns {*}
     * @memberof AuthManager
     */
    verified(closure) {
        if (this.verifiedPromise.resolved) {
            closure();
        }
        else {
            this.verifiedPromise.closures.push(closure);
        }
    }
    /**
     * Setta l'access token dopo la validazione del server
     *
     * @protected
     * @param {any} response
     * @memberof AuthManager
     */
    setAuthenticationAccessToken(response) {
        this.token.createFromResponse(response);
        api_1.Api.setAccessToken(this.token.getAccessToken());
    }
    /**
     * Cancella il token e l'utente
     *
     * @protected
     * @memberof AuthManager
     */
    unsetAuthenticationAccessToken() {
        this.token.destroy();
        this.setUser(null);
        api_1.Api.setAccessToken(null);
    }
    unsetAuthenticationAccessTokenIfErrorNotLegal(e) {
        if (e instanceof exceptions_1.UnavailableForLegalReasons) {
        }
        else {
            this.unsetAuthenticationAccessToken();
        }
    }
    /**
     * Ritorna il controllore del token
     *
     * @returns {AuthToken}
     * @memberof AuthManager
     */
    getAuthenticationAccessToken() {
        return this.token;
    }
    /**
     * Ritorna l'utente se collegato
     *
     * @returns {(void | IUser)}
     * @memberof AuthManager
     */
    getUser() {
        return this.user;
    }
    /**
     * Setta o cancella l'utente
     *
     * @param {any} response
     * @returns {void | User}
     * @memberof AuthManager
     */
    setUser(response) {
        this.user = response;
        this.updateCallbacks.forEach(c => c());
        return this.user;
    }
    isVerified() {
        return this.status === AuthManager.STATUS_VERIFIED;
    }
    /**
     * Verifica la validità del token salvato in locale
     *
     * @private
     * @returns {Promise<IUser>}
     * @memberof AuthManager
     * @throws UnauthorizedException
     */
    async verifyExistentToken() {
        this.token.isExpired() &&
            this.token.createFromResponse(await api_1.Api.request({
                url: 'auth/refresh',
                method: 'POST',
                body: this.token.getAccessToken(),
            }));
        return this.setUser(await api_1.Api.request({
            url: 'v1/me',
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + this.token.getAccessToken(),
            },
        }));
    }
    /**
     * Verifica la validità del token salvato in locale
     *
     * @returns {Promise<void>}
     * @memberof AuthManager
     * @throws UnauthorizedException
     */
    async verifyToken() {
        return new Promise(async (resolve) => {
            try {
                const user = (await (this.token.exists() ? this.verifyExistentToken() : Promise.resolve()));
                if (user) {
                    this.token.setValid(true);
                    api_1.Api.setAccessToken(this.token.getAccessToken());
                }
                events_1.Events.dispatch('auth:verified', user);
                resolve();
            }
            catch (e) {
                if (e instanceof exceptions_1.UnavailableForLegalReasons) {
                    api_1.Api.setAccessToken(this.token.getAccessToken());
                }
                else {
                    this.unsetAuthenticationAccessToken();
                }
                resolve();
            }
        });
    }
    /**
     * Aggiunge una callback
     *
     * @param {Function} callback
     * @memberof AuthManager
     */
    updated(callback) {
        this.updateCallbacks.push(callback);
    }
}
exports.default = AuthManager;
/**
 * Stato iniziale
 *
 * @private
 * @static
 * @type {string}
 * @memberof AuthManager
 */
AuthManager.STATUS_NOT_VERIFIED = 'not_verified';
/**
 * Stato dopo la verifica del token
 *
 * @private
 * @static
 * @type {string}
 * @memberof AuthManager
 */
AuthManager.STATUS_VERIFIED = 'verified';
